import { inject } from "@angular/core";
import { Router } from "@angular/router";

import { firstValueFrom } from "rxjs";
import { UserService } from "../services/user.service";
import { RootStore } from "../store/root.store";

export const authGuard = async () => {
  const router = inject(Router);
  const userService = inject(UserService);
  const rootStore = inject(RootStore);

  try {
    await firstValueFrom(userService.getUser());
    await firstValueFrom(userService.getOrganization());
    return true;
  } catch (error) {
    console.log(error);
    rootStore.userStore.clearAuthToken();
    router.navigate(["/login"]);
    return false;
  }
};
